export const getDefaultModulePath = (modules = []) => {
  if (!modules.length) return '/'

  const defaultModule = modules.reduce(
    (prev, curr) => (curr.sortOrder < prev.sortOrder ? curr : prev),
    modules[0],
  )

  return `/${defaultModule.name}`
}
